<template>
	<div id="app" class="main-wrapper" :class="[settings.Language.items[settings.Language.selected].name,setDeviceClass]">

		<!-- Aside overlay -->
		<div class="aside-overlay" :class="[{active: settingsActive},{active: referenceconditions}]"></div>

		<!-- Splash screen -->
		<div class="splash" :class="{active: splashActive}">
			<div class="splash__infobox">
				<h3 class="splash__title">ATLAS COPCO
					<br>HD Coolers Calculation Tool</h3>
				<!-- <h4 class="splash__subtitle">V 1.0.0</h4> -->
			</div>
		</div>

		<!-- Aside wrapper info -->
		<div class="aside-wrapper aside-wrapper--info" :class="{active: referenceconditions}">
			<div class="aside__header">
				<h3>{{$t('t-reference-conditions-explanation')}}</h3>
				<a class="aside__close" href="#" title="close" @click.prevent="toggleSettings(true)">
					<svg role="img">
						<use xlink:href="./assets/img/svg_sprite/svg_sprite.svg#btn-close"></use>
					</svg>
				</a>
			</div>
			<div class="aside__body">
				{{$t('t-reference-conditions-explanation-text')}}
				<table class="reference-conditions-table">
					<tr>
						<th>{{$t('t-unit')}}</th>
						<th>{{$t('t-pressure')}}</th>
						<th>{{$t('t-temperature')}}</th>
						<th>{{$t('t-Relativehumidity')}}</th>
					</tr>
					<tr v-for="(item , index) in referenceConditionsData" :key="('reftab' + index)">
						<td v-html="item.unit"></td>
						<td v-html="item.pressure"></td>
						<td v-html="item.temperature"></td>
						<td v-html="item.Relativehumidity"></td>
					</tr>
				</table>
			</div>
		</div>

		<!-- Aside wrapper settings -->
		<div class="aside-wrapper aside-wrapper--settings" :class="{active: settingsActive}">
			<div class="aside__header">
				<h3>{{$t('t-settings')}}</h3>
				<a class="aside__close" href="#" title="close" @click.prevent="toggleSettings(false)">
					<svg role="img">
						<use xlink:href="./assets/img/svg_sprite/svg_sprite.svg#btn-close"></use>
					</svg>
				</a>
			</div>
			<div class="aside__body">

				<div style="display:none">{{updateLanguage}}</div>
				<inputdropdown :item="settings.Language"></inputdropdown>

				<inputtabs :item="settings.CompressedAirFlow"></inputtabs>

				<inputtabs :item="settings.Pressure"></inputtabs>

				<inputtabs :item="settings.Temperature"></inputtabs>

				<inputtabs :item="settings.CoolingWaterflow"></inputtabs>

				<inputtabs :item="settings.CoolingWaterInput"></inputtabs>

				<inputtabs :item="settings.GlycolType"></inputtabs>

				<inputfield :item="settings.GlycolConcentrationInCoolingWater" :unit="'%'" :selectedindex="unitlist.selected"></inputfield>

				<h3 @click.prevent="toggleSettings(true)">
					<svg class="icon-warning" role="img">
						<use xlink:href="./assets/img/svg_sprite/svg_sprite.svg#warning2"></use>
					</svg>{{$t('t-reference-conditions')}}</h3>

				<inputfield :item="settings.ReferenceTemperature" :unit="settings.Temperature.items[settings.Temperature.selected].name" :selectedindex="unitlist.selected"></inputfield>

				<inputfield :item="settings.ReferencePressure" :unit="settings.Pressure.items[settings.Pressure.selected].name" :selectedindex="unitlist.selected"></inputfield>

				<inputfield :item="settings.ReferenceRelativeHumidity" :unit="'%'" :selectedindex="unitlist.selected"></inputfield>

			</div>
		</div>

		<!-- Header -->
		<header>
			<div class="header__inner">
				<div class="header__logo">
					<img src="./assets/img/css/logo.svg" alt="Atlas Copco logo">
				</div>
				<div class="header__title">
					<h2>{{$t('t-hd-coolers-calculation-tool')}}</h2>
				</div>
				<div class="header__btn">
					<!-- rotating class -->
					<a href="#" class="header__btn--info btn--toggle " data-aside-target="distribution" @click.prevent="sendReport()">
						<svg role="img">
							<use xlink:href="./assets/img/svg_sprite/svg_sprite.svg#btn-info"></use>
						</svg>
					</a>
					<a href="#" class="header__btn--settings" @click.prevent="toggleSettings(false)">
						<svg role="img">
							<use xlink:href="./assets/img/svg_sprite/svg_sprite.svg#btn-settings"></use>
						</svg>
					</a>
				</div>
			</div>
		</header>

		<!-- Main content -->
		<div class="content" :class="{active :isContentActive}">

			<div class="content-tabs">
				<div class="setting__option tabs" id="air-flow">
					<button v-for="(item,index) in unitlist.items" class="tab-btn" :class="{active : (unitlist.selected === index)}" :key="item.id" @click.prevent="unitlistClicked(index)">{{item.Model}}</button>
				</div>
			</div>
			<div class="content-settings">

				<!-- input left -->
				<div class="content-settings__box content-settings__box--left">
					<div class="content-settings__box--top">
						<h4>
							<svg class="icon-settings-box" role="img">
								<use xlink:href="./assets/img/svg_sprite/svg_sprite.svg#air"></use>
							</svg>{{$t('t-inlet-compressed-air')}}
						</h4>
						<inputComponent v-for="(item,index) in inletCompressedAir" :key="item.id" :item="item" :index="index" :Limitations="Limitations" :inputType="'Fluid'" :plugindataInput="plugindataInput"></inputComponent>
					</div>
					<div class="content-settings__box--bottom">
						<h4>
							<svg class="icon-settings-box" role="img">
								<use xlink:href="./assets/img/svg_sprite/svg_sprite.svg#water"></use>
							</svg>{{$t('t-cooling-water-input')}}
						</h4>
						<inputComponent v-for="(item,index) in coolingWateInput" :key="item.id" :item="item" :index="index" :Limitations="Limitations" :inputType="'Coolant'" :plugindataInput="plugindataInput"></inputComponent>
					</div>
				</div>

				<bg-image :unitlist="unitlist"></bg-image>

				<!-- output right -->
				<div class="content-settings__box content-settings__box--right content-settings__box--result">
					<div class="content-settings__box--top content-settings__box--top-result">
						<h4>
							<svg class="icon-settings-box" role="img">
								<use xlink:href="./assets/img/svg_sprite/svg_sprite.svg#air"></use>
							</svg>{{$t('t-outlet-compressed-air')}}
						</h4>
						<outputComponent v-for="(item,index) in outletCompressedAir" :key="item.id" :item="item" :index="index" :inputType="'Fluid'"></outputComponent>
					</div>
					<div class="content-settings__box--bottom">
						<h4>
							<svg class="icon-settings-box" role="img">
								<use xlink:href="./assets/img/svg_sprite/svg_sprite.svg#water"></use>
							</svg>{{$t('t-cooling-water-output')}}
						</h4>

						<outputComponent v-for="(item,index) in coolingWaterOuput" :key="item.id" :item="item" :index="index" :inputType="'Coolant'"></outputComponent>

					</div>

				</div>

			</div>
			<div class="hidden"></div>

		</div>

	</div>
</template>

<script>
import Vue from "vue";
import FastClick from "fastclick";

import { EventBus } from "./event-bus.js";
import pluginAPI from "./plugin.api.js";
import converter from "./convert.service";
import dataUnitlist from "./units/data.unitlist";

//import pdfmake from 'pdfmake'

//inputs
import inputComponent from "./components/shared/SettingInput.vue";
import outputComponent from "./components/shared/SettingOuput.vue";

import inputtabs from "./components/shared/input.tabs.vue";
import inputdropdown from "./components/shared/input.dropdown.vue";
import inputfield from "./components/shared/input.field.vue";

import BgImage from "./components/shared/BgImage.vue";

const _isDebug = true;

export default {
	name: "app",
	components: {
		inputComponent,
		outputComponent,
		inputtabs,
		inputdropdown,
		inputfield,
		BgImage
	},
	data() {
		return {
			cordova: Vue.cordova,
			browserFeatures: null,
			plugindataOutput: null,
			plugindataInput: {},
			plugindata: null,

			counter: 0,
			splashActive: false,
			referenceconditions: false,
			settingsActive: true,
			isContentActive: true,
			settings: this.$store.state.settings,
			unitlist: {
				selected: 0,
				items: []
			},
			//input -----------------------------------
			inletCompressedAir: [
				{
					name: "Flow",
					value: 250,
					inputParam: "CompressedAirFlow"
				},
				{
					name: "t-temperature",
					value: 140,
					inputParam: "Temperature"
				},
				{
					name: "t-pressure",
					value: 8,
					inputParam: "Pressure"
				}
			],
			coolingWateInput: [
				{
					name: "Delta T",
					value: 10,
					inputParam: "Temperature"
				},
				{
					name: "Flow",
					value: 0.27,
					inputParam: "CoolingWaterflow"
				},
				{
					name: "t-temperature",
					value: 25,
					inputParam: "Temperature"
				},
				{
					name: "t-pressure",
					value: 3,
					inputParam: "Pressure"
				}
			],
			//output ----------------------------------
			outletCompressedAir: [
				{
					name: "t-temperature",
					value: 34.4444,
					inputParam: "Temperature"
				},
				{
					name: "t-pressure",
					value: 7.4444444,
					inputParam: "Pressure"
				}
			],
			coolingWaterOuput: [
				{
					name: "Flow",
					value: 0.00026999956676767553,
					inputParam: "CoolingWaterflow"
				},
				{
					name: "t-temperature",
					value: 25.44444,
					inputParam: "Temperature"
				},
				{
					name: "t-pressure",
					value: 6.2444444,
					inputParam: "Pressure"
				}
			],
			referenceConditionsData: [
				{
					unit: "Nm3/h & Nm3/min",
					pressure: "1.013 bar(a)",
					temperature: "0 &#8451;",
					Relativehumidity: "0 %"
				},
				{
					unit: "Sm3/h",
					pressure: "1 bar(a)",
					temperature: "15.6 &#8451;",
					Relativehumidity: "0 %"
				},
				{
					unit: "scfm(ASME)",
					pressure: "14.7 psi(a)",
					temperature: "68 &#8457;",
					Relativehumidity: "36 %"
				},
				{
					unit: "scfm(CAGI)",
					pressure: "14.5 psi(a)",
					temperature: "68 &#8457;",
					Relativehumidity: "0 %"
				},
				{
					unit: "scfm(Can.)",
					pressure: "14.7 psi(a)",
					temperature: "70 &#8457;",
					Relativehumidity: "0 %"
				},
				{
					unit: "scfm(US)",
					pressure: "14.7 psi(a)",
					temperature: "60 &#8457;",
					Relativehumidity: "0 %"
				}
			],
			Limitations: {
				Fluid: {
					Temperature_Min: 274.15,
					Temperature_Max: 493.15,
					Pressure_Min: 100000.0,
					Pressure_Max: 2100000.0
				},
				Coolant: {
					Temperature_Min: 274.15,
					Temperature_Max: 368.15,
					Pressure_Min: 100000,
					Pressure_Max: 800000.0
				}
			}
		};
	},
	computed: {
		getUnitImage() {
			if (this.unitlist.items.length > 0) {
				let image = this.unitlist.items[this.unitlist.selected].Image;
				return image;
			}
		},
		updateLanguage() {
			let langObj = this.$store.state.settings.Language;
			let lang = langObj.items[langObj.selected].name;
			Vue.i18n.set(lang);
			return lang;
		},
		setDeviceClass() {
			if (this.browserFeatures === null) return "";

			let res = "";
			if (this.browserFeatures.bMobile)
				res = this.browserFeatures.bIos ? "ios" : "android";

			return res;
		}
	},
	methods: {
		sendReport() {
			//debugbos
			//#region debug
			var debugSendReport = false;
			if (debugSendReport) {
				this.plugindataInput = {
					Unit: {
						Model: "HD650"
					},
					Fluid: {
						Flow: 0.25,
						Temperature: 413.15,
						Pressure: 900000,
						Humidity: 0
					},
					Coolant: {
						GlycolType: "Ethylene",
						GlycolContent: 0.6,
						InputType: "DeltaT",
						Flow: 0.000272451,
						DeltaT: 25,
						Temperature: 298.15,
						Pressure: 400000
					},
					Reference: {
						Temperature: 298.15,
						Pressure: 100000,
						Humidity: 0.6
					}
				};

				this.plugindataOutput = {
					Result: 0,
					Msg: "Success",
					Fluid: {
						Flow: 0.25,
						Temperature: 315.3932073137327,
						Pressure: 849769.196480225,
						WaterContent: 0.0,
						Condensate: 0.008109182832328232338
					},
					Coolant: {
						Flow: 0.0002724508150486337,
						Temperature: 323.15,
						Pressure: 398111.76926710226
					},
					Dimensions: {
						Air_In: "DIN80",
						Air_Out: 'R2 1/2"',
						Coolant_In: 'R1/2"',
						Coolant_Out: 'R1/2"',
						Length: 0.58,
						Width: 0.62,
						Height: 2.11,
						Weight: 140.0
					},
					Limitations: {
						Fluid: {
							Temperature_Min: 274.15,
							Temperature_Max: 493.15,
							Pressure_Min: 100000.0,
							Pressure_Max: 2100000.0
						},
						Coolant: {
							Temperature_Min: 274.15,
							Temperature_Max: 368.15,
							Pressure_Min: 100000.0,
							Pressure_Max: 800000.0
						}
					}
				};
			}
			//#endregion

			/*
       let title = "<small style='color: #F27474'>Not implemented yet. <div v-html'this.browserFeatures.bMobile'></div></small>";// "<small>Error occurred</small>!";
       let body = "";//"<span style='color: #F27474'>Not implemented yet.<span>";

       swal({
         title: title,
         text: body,
         confirmButtonText: "ok",
         confirmButtonColor: '#0078A1',
         type: "error",
         html: true
       });
       */
			//this.plugindataOutput
			//this.plugindataInput
			let fflowUnit = this.settings["CompressedAirFlow"];
			let wflowUnit = this.settings["CoolingWaterflow"];
			let tempUnit = this.settings["Temperature"];
			let presUnit = this.settings["Pressure"];

			const unitSelected = this.unitlist.items[this.unitlist.selected];

			const sidemargin = this.unitlist.selected > 1 ? 40 : 70; //placement of unitimage in the pdf

			//console.log(unitSelected);
			let reportData = {
				Cooler: [
					["Size", unitSelected.Model] //getUnitList
					// ['Image', ''] //getUnitList
				],
				PerformanceData: [
					[
						"Air Temperature In",
						converter.getReportvalue(
							"Temperature",
							tempUnit,
							this.plugindataInput.Fluid.Temperature
						)
					],
					[
						"Air Temperature Out",
						converter.getReportvalue(
							"Temperature",
							tempUnit,
							this.plugindataOutput.Fluid.Temperature
						)
					],

					[
						"Air Pressure In",
						converter.getReportvalue(
							"Pressure",
							presUnit,
							this.plugindataInput.Fluid.Pressure,
							this.settings["ReferencePressure"].value
						)
					],
					[
						"Air Pressure Out",
						converter.getReportvalue(
							"Pressure",
							presUnit,
							this.plugindataOutput.Fluid.Pressure,
							this.settings["ReferencePressure"].value
						)
					],
					[
						"Air Pressure drop",
						converter.getReportvalue(
							"PressureNotA",
							presUnit,
							this.plugindataInput.Fluid.Pressure -
								this.plugindataOutput.Fluid.Pressure
						)
					],

					[
						"Air Flow In",
						converter.getReportvalue(
							"Flow",
							fflowUnit,
							this.plugindataInput.Fluid.Flow
						)
					],
					[
						"Air flow Out",
						converter.getReportvalue(
							"Flow",
							fflowUnit,
							this.plugindataOutput.Fluid.Flow
						)
					],

					[
						"Condensate",
						_.round(this.plugindataOutput.Fluid.Condensate, 6) + " kg/s"
					],

					[
						"Water Temperature In",
						converter.getReportvalue(
							"Temperature",
							tempUnit,
							this.plugindataInput.Coolant.Temperature
						)
					],
					[
						"Water Temperature Out",
						converter.getReportvalue(
							"Temperature",
							tempUnit,
							this.plugindataOutput.Coolant.Temperature
						)
					],
					[
						"Water Temperature Rise",
						converter.getReportvalue(
							"Calc",
							tempUnit,
							this.plugindataOutput.Coolant.Temperature -
								this.plugindataInput.Coolant.Temperature
						)
					],

					[
						"Water Pressure In",
						converter.getReportvalue(
							"Pressure",
							presUnit,
							this.plugindataInput.Coolant.Pressure,
							this.settings["ReferencePressure"].value
						)
					],
					[
						"Water Pressure Out",
						converter.getReportvalue(
							"Pressure",
							presUnit,
							this.plugindataOutput.Coolant.Pressure,
							this.settings["ReferencePressure"].value
						)
					],
					[
						"Water Pressure drop",
						converter.getReportvalue(
							"PressureNotA",
							presUnit,
							this.plugindataInput.Coolant.Pressure -
								this.plugindataOutput.Coolant.Pressure
						)
					],

					[
						"Water Flow",
						converter.getReportvalue(
							"WaterFlow",
							wflowUnit,
							this.plugindataOutput.Coolant.Flow
						)
					],

					["Glycol type", this.plugindataInput.Coolant.GlycolType],
					[
						"Glycol content",
						_.round(this.plugindataInput.Coolant.GlycolContent * 100, 1) + " %"
					]
				],
				Limitations: [
					[
						"Min Compressed Air Temperature",
						converter.getReportvalue(
							"Temperature",
							tempUnit,
							this.plugindataOutput.Limitations.Fluid.Temperature_Min
						)
					], //from output directly
					[
						"Max Compressed Air Temperature",
						converter.getReportvalue(
							"Temperature",
							tempUnit,
							this.plugindataOutput.Limitations.Fluid.Temperature_Max
						)
					], //from output directly
					[
						"Min Compressed Air Pressure",
						converter.getReportvalue(
							"Pressure",
							presUnit,
							this.plugindataOutput.Limitations.Fluid.Pressure_Min
						)
					], //from output directly
					[
						"Max Compressed Air Pressure",
						converter.getReportvalue(
							"Pressure",
							presUnit,
							this.plugindataOutput.Limitations.Fluid.Pressure_Max
						)
					], //from output directly
					[
						"Min Cooling Water Temperature",
						converter.getReportvalue(
							"Temperature",
							tempUnit,
							this.plugindataOutput.Limitations.Coolant.Temperature_Min
						)
					], //from output directly
					[
						"Max Cooling Water Temperature",
						converter.getReportvalue(
							"Temperature",
							tempUnit,
							this.plugindataOutput.Limitations.Coolant.Temperature_Max
						)
					], //from output directly
					[
						"Min Cooling Water Pressure",
						converter.getReportvalue(
							"Pressure",
							presUnit,
							this.plugindataOutput.Limitations.Coolant.Pressure_Min
						)
					], //from output directly
					[
						"Max Cooling Water Pressure",
						converter.getReportvalue(
							"Pressure",
							presUnit,
							this.plugindataOutput.Limitations.Coolant.Pressure_Max
						)
					] //from output directly
				],
				Dimensions: [
					["Air Inlet Connection", this.plugindataOutput.Dimensions.Air_In], //from output directly
					["Air Outlet Connection", this.plugindataOutput.Dimensions.Air_Out], //from output directly
					[
						"Water Inlet Connection",
						this.plugindataOutput.Dimensions.Coolant_In
					], //from output directly
					[
						"Water Outlet connection",
						this.plugindataOutput.Dimensions.Coolant_Out
					], //from output directly
					["Length", this.plugindataOutput.Dimensions.Length + " m"], //from output directly
					["Width", this.plugindataOutput.Dimensions.Width + " m"], //from output directly
					["Height", this.plugindataOutput.Dimensions.Height + " m"], //from output directly
					["Weight", this.plugindataOutput.Dimensions.Weight + " kg"] //from output directly
				],
				ReferenceConditions: [
					[
						"Reference Temperature",
						converter.getReportvalue(
							"Temperature",
							tempUnit,
							this.plugindataInput.Reference.Temperature
						)
					], //from input directly
					[
						"Reference Pressure",
						converter.getReportvalue(
							"PressureNotA",
							presUnit,
							this.plugindataInput.Reference.Pressure
						) + "(g)"
					], //from input directly
					[
						"Reference Humidity",
						_.round(this.plugindataInput.Reference.Humidity * 100, 1) + " %"
					] //from input directly
				]
				// tester: [
				//   [{ text: 'tester 4 cells ', style: 'lefta' }, { text: '2100000 kg', style: 'righta' }, { text: '2100000 kg', style: 'righta' }, { text: '2100000 kg', style: 'righta' }]
				// ]
			};

			if (pluginAPI.debugMode()) {
				//console.clear();
				console.log(JSON.stringify(reportData, null, 2));
			}

			//pdf setup
			const tableRowCellSize = ["*", 240];
			const tableRowCellSize4 = ["*", 90, 90, 90];
			const tableRowFillColor = "#EEF6F9";
			const tableHeaderColor = "#0099CC";
			const tableHeaderMargins = [0, 20, 0, 8];
			const tableLayout = {
				hLineWidth: function(i, node) {
					return i === 0 || i === node.table.body.length ? 0 : 1;
				},
				vLineWidth: function(i, node) {
					return i === 0 || i === node.table.widths.length ? 0 : 0;
				},
				hLineColor: function(i, node) {
					return i === 0 || i === node.table.body.length ? "white" : "#cacaca";
				},
				// vLineColor: function(i, node) {
				//   return (i === 0 || i === node.table.widths.length) ? 'white' : '#cacaca';
				// },
				fillColor: function(i, node) {
					return i % 2 === 0 ? tableRowFillColor : null;
				}
			};

			let dd = {
				content: [
					{
						image: dataUnitlist.getAClogo().image,
						width: 70
						// fit: [100, 100]
					},

					{
						text: "Cooler",
						margin: tableHeaderMargins,
						color: tableHeaderColor
					},
					{
						style: "tableExample",
						table: {
							widths: tableRowCellSize, //	widths: [100, '*', 200, '*'],
							body: reportData.Cooler
						},
						layout: tableLayout
					},

					// { text: 'tester', margin: tableHeaderMargins, color: tableHeaderColor },
					// {
					//     widths: tableRowCellSize4, //	widths: [100, '*', 200, '*'],
					//     body: reportData.tester
					//   },
					//   layout: tableLayout
					// },

					{
						text: "Performance Data",
						margin: tableHeaderMargins,
						color: tableHeaderColor
					},
					{
						style: "tableExample",
						table: {
							widths: tableRowCellSize, //	widths: [100, '*', 200, '*'],
							body: reportData.PerformanceData
						},
						layout: tableLayout
					},

					{
						text: "Limitations",
						margin: tableHeaderMargins,
						color: tableHeaderColor
					},
					{
						style: "tableExample",
						table: {
							widths: tableRowCellSize, //	widths: [100, '*', 200, '*'],
							body: reportData.Limitations
						},
						layout: tableLayout,
						pageBreak: "after"
					},

					{
						text: "Dimensions",
						margin: tableHeaderMargins,
						color: tableHeaderColor
					},
					{
						style: "tableExample",
						table: {
							widths: tableRowCellSize, //	widths: [100, '*', 200, '*'],
							body: reportData.Dimensions
						},
						layout: tableLayout
					},

					{
						text: "Reference conditions",
						margin: tableHeaderMargins,
						color: tableHeaderColor
					},
					{
						style: "tableExample",
						table: {
							headerRows: 1,
							widths: tableRowCellSize, //	widths: [100, '*', 200, '*'],
							body: reportData.ReferenceConditions
						},
						layout: tableLayout
						// paddingLeft: function(i, node) { return 4; },
						// paddingRight: function(i, node) { return 4; },
						// paddingTop: function(i, node) { return 2; },
						// paddingBottom: function(i, node) { return 2; },
						// fillColor: function (i, node) { return null; }
					},
					{
						style: "image",
						image: unitSelected.Image,
						fit: [300, 300],
						alignment: "right",
						margin: [sidemargin, 50]
					}
				],
				styles: {
					righta: {
						fontSize: 11,
						alignment: "right"
					},
					lefta: {
						fontSize: 11,
						alignment: "left"
					},
					image: {
						border: "1px solid red"
					}
				}
			};

			pluginAPI.openPDF(dd, unitSelected.Model);
		},
		unitlistClicked(index) {
			const _self = this;
			this.unitlist.selected = index;

			let unit = this.unitlist.items[index];

			let flowUnit = this.settings["CompressedAirFlow"].selected;
			let cflowUnit = this.settings["CoolingWaterflow"].selected;
			let tempUnit = this.settings["Temperature"].selected;
			let presUnit = this.settings["Pressure"].selected;

			//Disabled updating values
			// this.inletCompressedAir[0].value = converter.Flow(0, flowUnit, (unit['Fluid']['Flow'] * 1000));
			// this.inletCompressedAir[1].value = converter.fromKelvin(tempUnit, unit['Fluid']['Temperature']);
			// this.inletCompressedAir[2].value = converter.fromPascal(presUnit, (unit['Fluid']['Pressure']));

			// this.coolingWateInput[0].value = converter.CoolingWaterFlow(0, cflowUnit, (unit['Coolant']['Flow'] * 1000));
			// this.coolingWateInput[1].value = converter.fromKelvin(tempUnit, unit['Coolant']['Temperature']);
			// this.coolingWateInput[2].value = converter.fromPascal(presUnit, (unit['Coolant']['Pressure']));

			this.updateCalculation();
		},
		toggleSettings(showReferenceconditions = false) {
			if (showReferenceconditions)
				this.referenceconditions = !this.referenceconditions;

			this.settingsActive = !this.settingsActive;

			if (!this.settingsActive) {
				this.updateCalculation();
			}
		},
		updateCalculation() {
			let _self = this;
			let flowUnit = this.settings["CompressedAirFlow"].selected;
			let cflowUnit = this.settings["CoolingWaterflow"].selected;
			let tempUnit = this.settings["Temperature"].selected;
			let presUnit = this.settings["Pressure"].selected;

			//Inlet compressed air
			let fFlow =
				converter.Flow(flowUnit, 0, this.inletCompressedAir[0].value) / 1000;
			let fTemperature = converter.toKelvin(
				tempUnit,
				this.inletCompressedAir[1].value
			);
			let fPressure = converter.toPascal_a(
				presUnit,
				this.inletCompressedAir[2].value,
				this.settings["ReferencePressure"].value
			); //
			//let fPressure = converter.toPascal(presUnit, this.inletCompressedAir[2].value);
			//let fPressure = converter.fromPascal_a(presUnit, this.inletCompressedAir[2].value, this.settings['ReferencePressure'].value);

			//Cooling Water Input
			let cDelta = converter.toKelvinDeltaT(
				tempUnit,
				this.coolingWateInput[0].value
			);

			//updated as per mail
			let cFlow =
				converter.CoolingWaterFlow(
					cflowUnit,
					0,
					this.coolingWateInput[1].value
				) / 1000;
			// console.log()
			// let cFlow = this.coolingWateInput[1].value / 1000;

			let cTemperature = converter.toKelvin(
				tempUnit,
				this.coolingWateInput[2].value
			);

			let cPressure = converter.toPascal_a(
				presUnit,
				this.coolingWateInput[3].value,
				this.settings["ReferencePressure"].value
			); //converter.toPascal(presUnit, this.coolingWateInput[2].value);
			//let cPressure = converter.toPascal(presUnit, this.coolingWateInput[3].value);

			let rGlycolContent =
				this.settings["GlycolConcentrationInCoolingWater"].value / 100;
			let rTemperature = converter.toKelvin(
				tempUnit,
				this.settings["ReferenceTemperature"].value
			);
			let rPressure = converter.toPascal(
				presUnit,
				this.settings["ReferencePressure"].value
			);

			let rHumidity =
				this.unitlist.selected === 0 || this.unitlist.selected === 1
					? 0
					: this.settings["ReferenceRelativeHumidity"].value / 100;

			const cCoolingWaterInputType = this.settings.CoolingWaterInput.items[
				this.settings.CoolingWaterInput.selected
			].name.replace(/ /g, "");

			var obj = {
				Unit: {
					Model: this.unitlist.items[this.unitlist.selected].Model
				},
				Fluid: {
					Flow: fFlow, //m3/s
					Temperature: fTemperature, // K
					Pressure: fPressure, //Pa
					Humidity: rHumidity //Relative humidity between 0 and 1 (keep at 0 for HD250/HD650, or if unknown)
				},
				Coolant: {
					GlycolType: this.settings.GlycolType.items[
						this.settings.GlycolType.selected
					].name, //"Ethylene"
					GlycolContent: rGlycolContent, //Glycol content between 0 and 0.6,
					InputType: cCoolingWaterInputType, //
					Flow: cFlow, // m3/s
					DeltaT: cDelta, // K or Celsius, since it is a temperature difference. To convert from Rankine or Fahrenheit to Celsius or Kelvin, multiply by 5/9,
					Temperature: cTemperature, //K
					Pressure: cPressure //Pa
				},
				Reference: {
					Temperature: rTemperature, //this.settings.ReferenceTemperature.value,         // K
					Pressure: rPressure, //this.settings.ReferencePressure.value,             // Pa
					Humidity: rHumidity
				}
			};

			this.plugindataInput = obj;

			if (pluginAPI.debugMode()) {
				//console.clear();
				console.log("plugindataInput\n", JSON.stringify(obj));
			}

			pluginAPI.calculate(
				obj,
				function(json) {
					//console.clear();

					let pluginCBData = (!!window.cordova) ? JSON.parse(json) : json;

					if (pluginAPI.debugMode())
						console.log("plugindataOutput\n", pluginCBData);

					if (pluginCBData.Result !== 0) {
						window.AppVM.plugindataOutput = null;
						swal({
							title: "Error:" + pluginCBData.Result,
							text: pluginCBData.Msg,
							confirmButtonText: "ok",
							confirmButtonColor: "#0078A1",
							type: "error",
							html: true
						});
					} else {
						//set limitations
						_self.Limitations = pluginCBData["Limitations"];

						//set output fields (pressure out 'PA - ReferencePressure PA' converter.fromPascal_a)
						_self.outletCompressedAir[0].value = converter.fromKelvin(
							tempUnit,
							pluginCBData["Fluid"]["Temperature"]
						);
						_self.outletCompressedAir[1].value = converter.fromPascal_a(
							presUnit,
							pluginCBData["Fluid"]["Pressure"],
							_self.settings["ReferencePressure"].value
						);

						_self.coolingWaterOuput[0].value = converter.CoolingWaterFlow(
							0,
							cflowUnit,
							pluginCBData["Coolant"]["Flow"] / 0.001,
							2
						);
						_self.coolingWaterOuput[1].value = converter.fromKelvin(
							tempUnit,
							pluginCBData["Coolant"]["Temperature"]
						);
						_self.coolingWaterOuput[2].value = converter.fromPascal_a(
							presUnit,
							pluginCBData["Coolant"]["Pressure"],
							_self.settings["ReferencePressure"].value
						);

						window.AppVM.plugindataOutput = pluginCBData;
					}

					/*
					var debugInOut = {
						'input' :  obj,
						'output' : pluginCBData
					}

					console.log( JSON.stringify(debugInOut, null , "\t"));
					*/
				},
				function(json) {
					let msg = JSON.parse(json);
					if (pluginAPI.debugMode())
						console.error("plugindataOutput error:", json);
					window.AppVM.plugindataOutput = null;
					swal({
						title: "Plugin error:",
						text: msg.Msg,
						confirmButtonText: "ok",
						confirmButtonColor: "#0078A1",
						type: "error",
						html: true
					});
					window.AppVM.plugindataOutput = msg;
				}
			);
		},
		InitBrowserFeatures() {
			/* ===== BROWSER FEATURES ======================================================================= */
			function isInternetExplorer() {
				var isIE =
					navigator.appVersion.indexOf("MSIE") >= 0 &&
					navigator.appVersion.indexOf("MSIE") < 18;
				//$("body").addClass("is-ie");
				return isIE;
			}

			function isIos() {
				var ua = navigator.userAgent;
				return ua.match(/iPad/i) || ua.match(/iPhone/i) || ua.match(/iPod/i)
					? true
					: false;
			}

			function isMobile() {
				var bMobile = /iPhone|iPod|iPad|Android|BlackBerry/.test(
					navigator.userAgent
				);
				window.isOnMobile = bMobile;
				return bMobile;
			}

			/* Create object to store browser features */
			function getBrowserFeatures() {
				return {
					bIE: isInternetExplorer(),
					bIos: isIos(),
					bMobile: isMobile()
				};
			}

			function isInLandscapeMode() {
				return window.orientation === 90 || window.orientation === -90;
			}
			// Orientationchange
			window.addEventListener("orientationchange", () => {
				if (isInLandscapeMode()) {
					//alert("plase use in landscape mode")
				}
			});

			/* ============================================================================ */
			//test for touch events support and if not supported, attach .no-touch class to the HTML tag.
			if (!("ontouchstart" in document.documentElement)) {
				document.documentElement.className += " no-touch";
			} else {
				//Fastclick
				//console.log('FastClick attach');
				FastClick.attach(document.body);
			}

			this.browserFeatures = getBrowserFeatures();
		},
		initApp(isCordova) {
			console.log('initApp isCordova:',isCordova);
			pluginAPI.init();
			this.unitlistClicked(0);
		}
	},
	mounted: function() {
		// console.clear();
		EventBus.$on("updateCalculation", this.updateCalculation);
		let _self = this;
		window.AppVM = _self;

		_self.unitlist.items = dataUnitlist.getUnitList();

		//check if running cordova
		if (!!window.cordova) {
			//in browser
			_self.initApp(false);
		} else {
			//on device
			Vue.cordova.on("deviceready", () => {
				_self.initApp(true);
			});
		}

		this.InitBrowserFeatures();

		// https://github.com/jonathantneal/svg4everybody
		// SVG External Content support IE <= 11
		//svg4everybody();

		// setTimeout(function() {
		//   _self.sendReport();
		// }, 300);
	},
	beforeDestroy: function() {
		EventBus.$off("updateCalculation", this.updateCalculation);
	}
};
</script>

<style lang="scss">
.hidden {
	display: none;
	visibility: hidden;
}

// @import 'src/assets/src/scss/test.scss';
.aside-wrapper {
	backface-visibility: hidden !important;
}

//android optimizations
.android .aside-wrapper {
	box-shadow: none !important;
}

.android .aside-overlay {
	transition: none;
}

@-webkit-keyframes rotating
/* Safari and Chrome */ {
	from {
		-webkit-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	to {
		-webkit-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}

@keyframes rotating {
	from {
		-ms-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-webkit-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	to {
		-ms-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-webkit-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}

.rotating {
	-webkit-animation: rotating 2s linear infinite;
	-moz-animation: rotating 2s linear infinite;
	-ms-animation: rotating 2s linear infinite;
	-o-animation: rotating 2s linear infinite;
	animation: rotating 2s linear infinite;
}

.bgimage {
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;
	background-origin: content-box;
	padding: 2%;
}

.img-responsive {
	display: block;
	max-width: 100%;
	height: auto;
}

.slide-fade-enter-active {
	transition: all 0.3s ease;
}

.slide-fade-leave-active {
	transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */

 {
	// transform: translate3d(0,10px,0);
	opacity: 0;
}

// .slide-fade-enter-active {
//   transition: all .2s ease;
// }
// .slide-fade-leave-active {
//   transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
// }
// .slide-fade-enter,
// .slide-fade-leave-to {
//   opacity: 0;
// }
.reference-conditions-table {
	font-size: 12px;
	width: 100%;
	margin-top: 20px;

	th,
	td {
		font-weight: 300;
		border: 1px solid #e1e1e1;
		text-align: center;
		padding: 6px;
		margin: 0px;

		&:first-child {
			text-align: left;
		}
	}

	th {
		font-weight: 300;
		color: white;
		background: #0078a1;
		border: 1px solid #0078a1;
	}
}
</style>



// WEBPACK FOOTER //
// App.vue?214cbd93